import './footer.scss';
import logo from '../../../media/img/logo_wonderaly.png';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-columns">
        {/* Columna 1: Logo */}
        <div className="footer-column container-logo-footer">
          <img src={logo} alt="Logo Wonderaly" className="footer-logo" />
        </div>

        {/* Columna 2: Navegación */}
        <div className="footer-column">
          <h4 className="footer-title">WONDERALY</h4>
          <ul className="footer-links">
            <li>
              <a href="/">Home</a>
            </li>
            <li>
              <a href="/AboutUsPage">Nosotros</a>
            </li>
            <li>
              <a href="/productos/products">Proyectos</a>
            </li>
            <li>
              <a href="/productos/services">Servicios</a>
            </li>
            <li>
              <a href="/I+D+i">I+D+i</a>
            </li>
          </ul>
        </div>

        {/* Columna 3: General */}
        <div className="footer-column">
          <h4 className="footer-title">GENERAL</h4>
          <ul className="footer-links">
            <li>
              <a href="/Contacto">Contacto</a>
            </li>
            <li>
              <a href="#terms">Términos de Servicio</a>
            </li>
            <li>
              <a href="#agreement">Acuerdo de Equipo</a>
            </li>
            <li>
              <a href="#privacy">Privacidad</a>
            </li>
          </ul>
        </div>

        {/* Columna 4: Redes sociales */}
        <div className="footer-column">
          <h4 className="footer-title">SÍGUENOS</h4>
          <ul className="footer-links">
            <li>
              <a href="#linkedin">LinkedIn</a>
            </li>
            <li>
              <a href="#twitter">X / Twitter</a>
            </li>
            <li>
              <a href="#instagram">Instagram</a>
            </li>
          </ul>
        </div>
      </div>

      <div className="footer-bottom">
        <p>© 2026 WONDERALY INNOVATIONS SL. Todos los derechos reservados.</p>
      </div>
    </footer>
  );
};

export default Footer;
